import BaseException from "exceptions/BaseException";

export default class AuthException extends BaseException {
    readonly name = 'AuthException';
}
